import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import TextField from "@material-ui/core/TextField";
import Modal from 'react-bootstrap/Modal';
import { useAppDispatch, useAppSelector } from '../../useStore';
import swal from 'sweetalert';
import { reset, sendEmail } from '../../features/Applicant/applicantSlice';
import { Spinners } from '../TableOptions';
import ModalHeader from '../ModalHeader';


const WelcomeEmail = ({ title, name, email }) => {
	const dispatch = useAppDispatch();
	const { sendEmailisError, sendEmailmessage, sendEmailisLoading, sendEmailisSuccess } = useAppSelector((state: { applicant: any; }) => state.applicant)

	const [inputs, setInputs] = useState({
		email: "",
		body: "",
		subject: "Welcome to [Company_name]!"
	});

	const [welcome, setWelcome] = useState(false);
	const handleCloseWelcome = () => setWelcome(false);
	const handleWelcome = () => setWelcome(true);


	useEffect(() => {
		if (sendEmailisError) {
			swal({
				title: "error",
				text: sendEmailmessage,
				icon: "error"
			})
		} else if (sendEmailisSuccess) {
			swal({
				title: "success",
				text: "Email Sent!",
				icon: "success"
			})
			setWelcome(false)
			setInputs(
				{
					email: "",
					body: "",
					subject: ""
				}
			)
		}
		dispatch(reset())
	}, [sendEmailisError, sendEmailisSuccess, sendEmailmessage, dispatch])



	const handleOnChange = (input: any, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};

	const text = `Dear [employee’s name]

		Welcome on board! We’re delighted that you are joining us.We were impressed with your background and skills and we can’t wait to see you in action.

		Please come in on [insert date]at our offices [insert address / floor], where Human Resources will be be there to welcome you.We have organized your first day to help you settle in properly.Here’s an outline of what to expect:

		You will take some time at the beginning to sign the employment contract and any other necessary paperwork
You will familiarize yourself with your workstation and set up accounts and any other hardware
You’ll get time with your team leader who will brief you on the position and responsibilities
We’ll have induction training on the basics like policies, company products and perks
At lunchtime, HR will introduce you to your colleagues
To help you familiarize yourself with the company, we have arranged your access to our employee directory here: [insert link].We want to ensure that you feel comfortable and hit the ground running.

		Our dress code is [business casual].Don’t forget to bring your ID.We have enclosed benefit forms and the employment contract so you can have time to review them before you sign.

		You can find out more about the company’s culture in our Employee Handbook(enclosed).We’re confident that you’ll be a real asset for our company.Looking forward to welcoming you in person!

		Yours,

		[Your name]
				[Your signature]`

	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				email: email,
				subject: text.split("\n")[0],
				body: text.split("\n").slice(1).join("\n")

			});
		});
	}, [inputs.email, setInputs, email, text]);


	const handleSendEmail = () => {
		// @ts-ignore  
		dispatch(sendEmail(inputs));
	}

	return (
		<>
			<div onClick={handleWelcome} className="more-button">
				{title}
			</div>

			<Modal show={welcome} onHide={handleCloseWelcome}>
				<ModalHeader setShow={setWelcome} headerTitle={"Send Welcome Email"} />
				<Modal.Body>
					<form>
						<div className='applicant-name'>
							<h5>Applicant Name</h5>
							<p>{name}</p>
						</div>

						<div className="welcome-email" style={{ marginTop: "20px" }}>
							<h5>Subject</h5>
							<TextField id="outlined-multiline-static"

								multiline
								fullWidth
								type="text"
								minRows={2}
								variant="outlined"
								style={{ margin: "10px 0" }}
								value={inputs.subject}
								onChange={(e) => handleOnChange("subject", e.target.value)} />
						</div>

						<div className="welcome-email">
							<h5>Email Body</h5>
							<TextField id="outlined-multiline-static"

								multiline
								fullWidth
								type="text"
								minRows={5}
								variant="outlined"
								style={{ margin: "10px 0" }}
								value={inputs.body}
								onChange={(e) => handleOnChange("body", e.target.value)} />
						</div>
					</form>

				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleCloseWelcome}>
						Cancel
					</Button>
					<Button id="primary" onClick={handleSendEmail}>
						{sendEmailisLoading ? <Spinners size={"sm"} /> : 'Send'}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default WelcomeEmail